import { Step } from 'app/modules/step-engine/utils/step-engine-constants';
import _ from 'lodash';
import moment from 'moment';

/* eslint-disable complexity */
export const stickyStepsMapper = (dataKey, cms, globalData) => {
  let gtmAnswer;
  const dataKeyCamelCase = Step[dataKey]
  const currentCmsContent = cms[dataKeyCamelCase]?.prismic || {};
  switch (dataKeyCamelCase) {
    case Step.DAMAGED_GOOD_DATE:// Hier/Aujourd'hui/ DD/MM/YYYY
      if (moment(globalData[dataKeyCamelCase]?.value?.substring(0, globalData[dataKeyCamelCase].value.indexOf("T")), "YYYY-MM-DD", true).isValid())
        gtmAnswer = moment(globalData[dataKeyCamelCase].value).format('DD/MM/YYYY');
      else
        gtmAnswer = globalData[dataKeyCamelCase]?.sort((a, b) =>
          a.brand ? a.brand.localeCompare(b.brand) : a.code - b.code).map(e =>
            e.brand ? e.brand + " " + (e.modal ?? e.model) : e.label).join(" & ");
      break;
    case Step.COVER_SELECTION:
    case Step.CLAIM_LOCATION:
    case Step.BENEFIT_TYPE_SELECTION:
    case Step.BENEFIT_TYPE_SELECTION_APPLE:
    case Step.BENEFIT_DEPOSIT_METHOD:
    case Step.STOLEN_TYPE_SELECTION:
    case Step.BURGLARY_DEVICE_SELECTION:
    case Step.DAMAGED_GOOD_IMEI_VALIDATION:
    case Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION:
    case Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION:
    case Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION:
    case Step.EXTERNAL_DAMAGE_CONFIRMATION:
    case Step.OTHER_CLAIM_TRIGGER_NATURE:
    case Step.RECOVERY_METHOD:
    case Step.COMPLAINED_TO_POLICE_CONFIRMATION:
      gtmAnswer = globalData[dataKeyCamelCase]?.label;
      break;
    case Step.DAMAGED_GOOD_ACCESSORIES_VALIDATION:
    case Step.THEFT_ACCESSORIES_VALIDATION:
      gtmAnswer = globalData[dataKeyCamelCase]?.label;
      globalData[dataKeyCamelCase].description ? gtmAnswer = (_.truncate(globalData[dataKeyCamelCase].description, { length: 20 })) : NaN;
      break;
    case Step.CHOOSE_DAMAGED_GOODS:
    case Step.DAMAGED_GOOD_SELECTION:
      // On trie par marque ou par label
      if (Array.isArray(globalData[dataKeyCamelCase]) && globalData[dataKeyCamelCase].length === 0)
        gtmAnswer = "Autre appareil";
      else
        gtmAnswer = globalData[dataKeyCamelCase]?.sort((a, b) =>
          a.brand ? a.brand.localeCompare(b.brand) : a.code - b.code).map(e =>
            (e.model?.toUpperCase()?.includes(e.brand?.toUpperCase()) ? e.model : e.brand + " " + e.model)).join(" & ");
      break;
    case Step.CLAIM_TRIGGER_NATURE:
    case Step.CLAIM_RESULT_SELECTION:
    case Step.THEFT_PLACE_SELECTION:
      // On affiche les 2 premiers items avec  "+ X" si plus de 2 items
      gtmAnswer = globalData[dataKeyCamelCase].sort((a, b) => a.code - b.code).slice(0, 2).map(e => e.label).join(" & ");
      gtmAnswer += globalData[dataKeyCamelCase].length > 2 ? " +" + (globalData[dataKeyCamelCase].length - 2).toString() : "";
      break;
    case Step.DAMAGED_GOOD_DYSFUNCTION_SELECTION:
      gtmAnswer = globalData[dataKeyCamelCase].sort((a, b) => a.code - b.code).slice(0, 2).map(e => e.label).join(" & ");
      gtmAnswer += globalData[dataKeyCamelCase].length > 2 ? " +" + (globalData[dataKeyCamelCase].length - 2).toString() : "";
      gtmAnswer = gtmAnswer.split('&')?.map(answer => _.truncate(answer, { length: 20 }));
      break;
    case Step.BENEFIT_POINT_SELECTION:
      gtmAnswer = globalData[dataKeyCamelCase]?.name;
      break;
    case Step.UPDATE_BENEFIT_ADDRESS_DETAILS:
    case Step.UPDATE_RECOVERY_ADDRESS:
      gtmAnswer = `${globalData[dataKeyCamelCase].streetNumber} ${globalData[dataKeyCamelCase].address} ${globalData[dataKeyCamelCase].zipCode} ${globalData[dataKeyCamelCase].city}`;
      break;
    case Step.EXTERNAL_REFERENCE:
    case Step.DAMAGED_GOOD_CIRCONSTANCES:
    case Step.DAMAGE_OBSERVED_FREE_ENTRY:
    case Step.CLAIM_RESULT_FREE_ENTRY:
    case Step.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY:
      gtmAnswer = _.truncate(
        globalData[dataKeyCamelCase], {
        length: 30
      });
      break;
    case Step.DEVICE_PATTERN_LOCK:
      gtmAnswer = _.truncate(
        globalData[dataKeyCamelCase]?.without ? 'Aucun' : globalData[dataKeyCamelCase]?.value, {
        length: 30
      });
      break;
    case Step.CUSTOMER_INFORMATION:
      gtmAnswer = [
        globalData[dataKeyCamelCase]?.civility &&
        currentCmsContent?.items.find(item => item.code === globalData[dataKeyCamelCase].civility)?.value + '<br/>',
        globalData[dataKeyCamelCase]?.lastName && globalData[dataKeyCamelCase].lastName + '<br/>',
        globalData[dataKeyCamelCase]?.firstName && globalData[dataKeyCamelCase].firstName + '<br/>',
        globalData[dataKeyCamelCase]?.adressePostal?.streetNumber && globalData[dataKeyCamelCase].adressePostal?.streetNumber + '<br/>',
        globalData[dataKeyCamelCase]?.adressePostal?.address && globalData[dataKeyCamelCase].adressePostal?.address + '<br/>',
        globalData[dataKeyCamelCase]?.adressePostal?.postalCode && globalData[dataKeyCamelCase].adressePostal?.postalCode + '<br/>',
        globalData[dataKeyCamelCase]?.adressePostal?.city && globalData[dataKeyCamelCase].adressePostal?.city + '<br/>',
        globalData[dataKeyCamelCase]?.email && globalData[dataKeyCamelCase].email + '<br/>',
        globalData[dataKeyCamelCase]?.phoneNumber && globalData[dataKeyCamelCase].phoneNumber + '<br/>',
      ].join('');
      break;

    case Step.DAMAGED_GOOD_ACCESSORIES_SELECTION:
      // On affiche les 2 premiers items avec  "+ X" si plus de 2 items
      gtmAnswer = globalData[dataKeyCamelCase] ? globalData[dataKeyCamelCase]?.sort((a, b) => a.code - b.code).slice(0, 2)?.map(e => e.label)?.join(" & ") : "";
      gtmAnswer += globalData[dataKeyCamelCase]?.length > 2 ? " +" + (globalData[dataKeyCamelCase]?.length - 2).toString() : "";
      // const purchasePrice=globalData[dataKeyCamelCase]?.reduce((a,b)=>a?.value+b?.value,0)
      // gtmAnswer += purchasePrice ? " " + purchasePrice + "€" : "";

      break;
    case Step.UPLOAD_DECLARATION:
      gtmAnswer = globalData[dataKeyCamelCase]?.length > 0 ? globalData[dataKeyCamelCase]?.length + " document" : "";
      gtmAnswer += globalData[dataKeyCamelCase]?.length > 1 ? "s" : "";
      break;
    default:
      gtmAnswer = undefined
      break;
  }
  return gtmAnswer;
};